const currentEnv = process.env.HOST_ENV;

const appUrl = () => {
    const urls = {
        LOCAL: "http://localhost:3000",
        QA: "https://c2b-website.qac24svc.dev",
        STAGING: "https://stage-c2b-website.qac24svc.dev",
        LNOD: "https://stage-c2b-website.qac24svc.dev",
        PRODUCTION: "https://www.cars24.com"
    };
    return urls[currentEnv];
};

const homepageIndiaWebsiteUrl = () => {
    const urls = {
        QA: "https://home-page-india-website.qac24svc.dev/",
        STAGING: "https://stage-home-page-india-website.qac24svc.dev/",
        LNOD: "https://stage-home-page-india-website.qac24svc.dev/",
        PRODUCTION: "https://www.cars24.com"
    };
    return urls[currentEnv];
};

const vasIndiaWebsiteUrl = () => {
    const urls = {
        QA: "https://vas-india-website.qac24svc.dev",
        STAGING: "https://stage-vas-india-website.qac24svc.dev",
        LNOD: "https://stage-vas-india-website.qac24svc.dev",
        PRODUCTION: "https://www.cars24.com"
    };
    return urls[currentEnv];
};

const supplyIndiaWebsiteUrl = () => {
    const urls = {
        QA: "https://supply-india-website.qac24svc.dev",
        STAGING: "https://stage-supply-india-website.qac24svc.dev",
        LNOD: "https://stage-supply-india-website.qac24svc.dev",
        PRODUCTION: "https://www.cars24.com"
    };
    return urls[currentEnv];
};

const baseApiUrl = () => {
    const urls = {
        LOCAL: "https://sell24-engine.qac24svc.dev",
        QA: "https://sell24-engine.qac24svc.dev",
        STAGING: "https://stage-sell24-engine.qac24svc.dev",
        LNOD: "https://stage-sell24-engine.qac24svc.dev",
        PRODUCTION: "https://api-sell24.cars24.team"
    };
    return urls[currentEnv];
};

const apiUrl = () => {
    const urls = {
        LOCAL: "https://c2c-web.qac24svc.dev",
        STAGING: "https://api-staging.qac24svc.dev",
        QA: "https://api-se-qa1.qac24svc.dev",
        LNOD: "https://sellerengine-qa8.ninja24.in",
        PRODUCTION: "https://api.cars24.com"
    };
    return urls[currentEnv];
};

const ssrApiUrl = () => {
    const urls = {
        LOCAL: "http://c2c-web.qac24svc.dev",
        STAGING: "http://api-staging.qac24svc.dev",
        QA: "http://api-se-qa1.qac24svc.dev",
        LNOD: "http://sellerengine-qa8.ninja24.in",
        PRODUCTION: "http://api.cars24.com"
    };
    return urls[currentEnv];
};

const vehicleApiUrl = () => {
    const urls = {
        LOCAL: "https://vehicle-service-qa.qac24svc.dev",
        STAGING: "https://vehicle-service-stage.qac24svc.dev",
        QA: "https://vehicle-service-qa.qac24svc.dev",
        LNOD: "https://vehicle-service-qa.qac24svc.dev",
        PRODUCTION: "https://vehicle.cars24.team"
    };
    return urls[currentEnv];
};

const vehicleSSRApiUrl = () => {
    const urls = {
        LOCAL: "http://vehicle-service.qac24svc.dev",
        STAGING: "https://vehicle-service-stage.qac24svc.dev",
        QA: "https://vehicle-service-qa.qac24svc.dev",
        LNOD: "http://vehicle-service.qac24svc.dev",
        // PRODUCTION: "https://vehicle.cars24.team"
        PRODUCTION: "http://c2b-vehicle-service.cars24.internal"
    };
    return urls[currentEnv];
};

const staticFastlyAppUrl = () => {
    const urls = {
        LOCAL: "https://fastly-production.24c.in",
        QA: "https://fastly-production.24c.in",
        STAGING: "https://fastly-production.24c.in",
        LNOD: "https://fastly-production.24c.in",
        PRODUCTION: "https://fastly-production.24c.in"
    };
    return urls[currentEnv];
};

const getPrivateProductApiKey = () => {
    const urls = {
        QA: "c2c-s4583HJKH58",
        STAGING: "pp-ui-s32578KJDHS",
        PRODUCTION: "qGuMZcWGxZpgd8uSH4rgkal4v1evAlCd"
    };
    return urls[currentEnv];
};

const getC2bProductApiKey = () => {
    const urls = {
        QA: "seller_engine_mweb_12985",
        STAGING: "seller_engine_mweb_12985",
        PRODUCTION: "K3USo6xQXQ&bn!Eu@x&LVWjy74eoGaVq"
    };
    return urls[currentEnv];
};

const ppApiUrl = () => {
    const urls = {
        LOCAL: "https://pvt-product.qac24svc.dev",
        QA: "https://pvt-product.qac24svc.dev",
        STAGING: "https://stage-pvt-product.qac24svc.dev",
        LNOD: "https://stage-pvt-product.qac24svc.dev",
        PRODUCTION: "https://pvt-product.cars24.com"
    };
    return urls[currentEnv];
};

const c2bKeys = {
    LOCAL: "YzJiX2Zyb250ZW5kOmJBVllHRVlzODZIWDVDd01jcmo5M01DQklvOEs2b2xo",
    QA: "YzJiX2Zyb250ZW5kOkszcHJyT0cwNm1uZE41V0FMS0NTQUxuQVd3eHBXQ0hJ",
    STAGING: "YzJiX2Zyb250ZW5kOmJBVllHRVlzODZIWDVDd01jcmo5M01DQklvOEs2b2xo",
    PRODUCTION: "YzJiX2Zyb250ZW5kOko1SXRmQTk2bTJfY3lRVk00dEtOSnBYaFJ0c0NtY1h1"
};

const c2bAuthKey = () => {
    return c2bKeys[currentEnv];
};

const lmsBaseApiUrl = () => {
    const urls = {
        LOCAL: "https://c2c-lms.qac24svc.dev",
        STAGING: "https://c2c-lms-stage.cars24.team",
        QA: "https://c2c-lms.qac24svc.dev",
        LNOD: "https://c2c-lms.qac24svc.dev",
        PRODUCTION: "https://c2c-lms.cars24.team"
    };
    return urls[currentEnv];
};

const lmsAuthKey = () => {
    const keys = {
        LOCAL: "8a223df3-9fbd-426e-aa2f-e79bdcf60f61",
        QA: "8a223df3-9fbd-426e-aa2f-e79bdcf60f61",
        STAGING: "01e72f78-24f1-434a-ab6b-3342d75c352e",
        PRODUCTION: "b78f06db-d0d7-4c60-b1a6-fc153d2527be"
    };
    return keys[currentEnv];
};

const lmsLeadAuthKey = () => {
    const keys = {
        LOCAL: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        QA: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        STAGING: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        PRODUCTION: "6f355999-4af7-4c3a-8816-a16aaf2d8994"
    };
    return keys[currentEnv];
};

const getLogoURL = () => {
    return `${staticFastlyAppUrl()}/cars24/seo/static/1_20230830_1693395013.png`;
};

const getDiyOgImageUrl = () => {
    return `${staticFastlyAppUrl()}/cars24/seo/static/53_20230201_1675251512.jpg`;
};

const exchangeApiUrl = () => {
    const urls = {
        LOCAL: "https://c2b-website.qac24svc.dev",
        QA: "https://exchange-service-qa.ninja24.in",
        STAGING: "https://exchange-service-stage.cars24.team",
        LNOD: "https://exchange-service-qa.ninja24.in",
        PRODUCTION: "https://exchange-service.cars24.team"
    };
    return urls[currentEnv];
};

const checkoutApiSSRUrl = () => {
    const urls = {
        LOCAL: "https://b2c-oms.qac24svc.dev",
        QA: "https://b2c-oms.qac24svc.dev",
        STAGING: "http://stage-b2c-oms.qac24svc.dev",
        LNOD: "https://b2c-oms.qac24svc.dev",
        PRODUCTION: "https://b2c-oms.c24.tech"
    };
    return urls[currentEnv];
};

const checkoutApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-oms.qac24svc.dev",
        QA: "https://b2c-oms.qac24svc.dev",
        STAGING: "https://stage-b2c-oms.qac24svc.dev",
        LNOD: "https://b2c-oms.qac24svc.dev",
        PRODUCTION: "https://b2c-oms.c24.tech"
    };
    return urls[currentEnv];
};

const omsAggregatorApiSSRUrl = () => {
    const urls = {
        LOCAL: "http://oms-aggregator-service.qac24svc.dev",
        QA: "http://oms-aggregator-service.qac24svc.dev",
        STAGING: "http://stage-oms-aggregator-service.qac24svc.dev",
        LNOD: "http://oms-aggregator-service.qac24svc.dev",
        PRODUCTION: "http://oms-aggregator-service.c24.tech"
    };
    return urls[currentEnv];
};

const omsAggregatorApi = () => {
    const urls = {
        LOCAL: "https://oms-aggregator-service.qac24svc.dev",
        QA: "https://oms-aggregator-service.qac24svc.dev",
        STAGING: "https://stage-oms-aggregator-service.qac24svc.dev",
        LNOD: "https://oms-aggregator-service.qac24svc.dev",
        PRODUCTION: "https://oms-aggregator-service.c24.tech"
    };
    return urls[currentEnv];
};

const consumerFinanceApiUrl = () => {
    const urls = {
        LOCAL: "https://stage-api.theloan24.in/",
        QA: "https://stage-api.theloan24.in/",
        STAGING: "https://stage-api.theloan24.in/",
        LNOD: "https://stage-api.theloan24.in/",
        PRODUCTION: "https://api-gtw.loans24.co.in/"
    };
    return urls[currentEnv];
};

const consumerFinanceSSRApiUrl = () => {
    const urls = {
        LOCAL: "https://stage-api.theloan24.in/",
        QA: "https://stage-api.theloan24.in/",
        STAGING: "https://stage-api.theloan24.in/",
        LNOD: "https://stage-api.theloan24.in/",
        PRODUCTION: "https://api-gtw.loans24.co.in/"
    };
    return urls[currentEnv];
};

const getConsumerFinanceMobileApiKey = () => {
    const keys = {
        QA: "17d12855-df5d-4971-b4eb-dc3e3cd283aa",
        STAGING: "17d12855-df5d-4971-b4eb-dc3e3cd283aa",
        PRODUCTION: "a981279c-5880-463e-b1b2-587112f240ea"
    };
    return keys[currentEnv];
};

const getConsumerFinanceDesktopApiKey = () => {
    const keys = {
        QA: "17d12855-df5d-4971-b4eb-dc3e3cd283aa",
        STAGING: "17d12855-df5d-4971-b4eb-dc3e3cd283aa",
        PRODUCTION: "3e54f277-5dec-44d0-ac75-0b7eeb4a7595"
    };
    return keys[currentEnv];
};

const listingApiUrl = () => {
    const urls = {
        LOCAL: "https://listing-service.qac24svc.dev",
        QA: "https://listing-service.qac24svc.dev",
        STAGING: "https://stage-listing-service.qac24svc.dev",
        LNOD: "https://listing-service.qac24svc.dev",
        PRODUCTION: "https://listing-service.c24.tech"
    };
    return urls[currentEnv];
};

const leadApiUrlKey = () => {
    const keys = {
        LOCAL: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        QA: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        STAGING: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        PRODUCTION: "6f355999-4af7-4c3a-8816-a16aaf2d8994"
    };
    return keys[currentEnv];
};

const leadServiceJavaApi = () => {
    const urls = {
        LOCAL: "https://lead-service-java-qa.qac24svc.dev",
        STAGING: "https://lead-service-java-stage.qac24svc.dev",
        QA: "https://lead-service-java-qa.qac24svc.dev",
        LNOD: "https://lead-service-java-qa.qac24svc.dev",
        PRODUCTION: "https://seller-lead.cars24.team"
    };
    return urls[currentEnv];
};

const leadServiceJavaSSRApi = () => {
    const urls = {
        LOCAL: "http://lead-service-java.qac24svc.dev",
        // STAGING: "http://lead-service-java.stage",
        STAGING: "https://lead-service-java-stage.qac24svc.dev",
        QA: "https://lead-service-java-qa.qac24svc.dev",
        // QA: "http://lead-service-java.qa",
        LNOD: "http://lead-service-java.qac24svc.dev",
        // PRODUCTION: "https://seller-lead.cars24.team",
        PRODUCTION: "http://c2b-lead-service.cars24.internal"
    };
    return urls[currentEnv];
};

const b2cUserServiceUrl = () => {
    const urls = {
        LOCAL: "https://b2c-user-service.qac24svc.dev",
        STAGING: "https://stage-b2c-user-service.qac24svc.dev",
        QA: "https://b2c-user-service.qac24svc.dev",
        LNOD: "https://b2c-user-service.qac24svc.dev",
        PRODUCTION: "https://b2c-user-service.c24.tech"
    };
    return urls[currentEnv];
};

const carConsumerGatewayApi = () => {
    const urls = {
        LOCAL: "https://cars-consumer-gateway-qa.qac24svc.dev",
        STAGING: "https://cars-consumer-gateway-stage.qac24svc.dev",
        QA: "https://cars-consumer-gateway-qa.qac24svc.dev",
        LNOD: "https://cars-consumer-gateway-qa.qac24svc.dev",
        PRODUCTION: "https://cars-consumer.cars24.team"
    };
    return urls[currentEnv];
};

const carConsumerGatewaySSRApi = () => {
    const urls = {
        LOCAL: "https://cars-consumer-gateway-qa.qac24svc.dev",
        STAGING: "https://cars-consumer-gateway-stage.qac24svc.dev",
        QA: "https://cars-consumer-gateway-qa.qac24svc.dev",
        LNOD: "https://cars-consumer-gateway-qa.qac24svc.dev",
        // PRODUCTION: "http://cars-consumer.cars24.team",
        PRODUCTION: "http://cars-consumer-prod.cars24.internal"
    };
    return urls[currentEnv];
};

const incidentManagement = () => {
    const urls = {
        LOCAL: "https://incident-management-system.qac24svc.dev",
        STAGING: "https://stage-incident-management-system.qac24svc.dev",
        QA: "https://incident-management-system.qac24svc.dev",
        LNOD: "https://incident-management-system.qac24svc.dev",
        PRODUCTION: "https://incident-management-system.c24.tech"
    };
    return urls[currentEnv];
};

const b2cCrmServiceUrl = () => {
    const urls = {
        LOCAL: "https://b2c-crm.qac24svc.dev",
        STAGING: "https://stage-b2c-crm.qac24svc.dev",
        QA: "https://b2c-crm.qac24svc.dev",
        LNOD: "https://b2c-crm.qac24svc.dev",
        PRODUCTION: "https://b2c-crm.c24.tech"
    };
    return urls[currentEnv];
};

const couponServiceUrl = () => {
    const urls = {
        LOCAL: "https://coupon-service.qac24svc.dev",
        STAGING: "https://stage-coupon-service.qac24svc.dev",
        QA: "https://coupon-service.qac24svc.dev",
        LNOD: "https://coupon-service.qac24svc.dev",
        PRODUCTION: "https://coupon-service.c24.tech"
    };
    return urls[currentEnv];
};

const catalogServiceUrl = () => {
    const urls = {
        LOCAL: "https://b2c-catalog-service.qac24svc.dev",
        STAGING: "https://stage-b2c-catalog-service.qac24svc.dev",
        QA: "https://b2c-catalog-service.qac24svc.dev",
        LNOD: "https://b2c-catalog-gateway.qac24svc.dev",
        PRODUCTION: "https://b2c-catalog-service.c24.tech"
    };
    return urls[currentEnv];
};

const cfLoanServiceUrl = () => {
    const urls = {
        LOCAL: "https://dev-fin-partner.theloan24.in",
        STAGING: "https://stage-fin-partner.theloan24.in",
        QA: "https://stage-fin-partner.theloan24.in",
        LNOD: "https://stage-fin-partner.theloan24.in",
        PRODUCTION: "https://prod-fin-partner.theloan24.in"
    };
    return urls[currentEnv];
};

const catalogGatewayUrl = () => {
    const urls = {
        LOCAL: "https://b2c-catalog-gateway.qac24svc.dev",
        STAGING: "https://stage-b2c-catalog-gateway.qac24svc.dev",
        QA: "https://b2c-catalog-gateway.qac24svc.dev",
        LNOD: "https://b2c-catalog-gateway.qac24svc.dev",
        PRODUCTION: "https://b2c-catalog-gateway.c24.tech"
    };
    return urls[currentEnv];
};

const catalogGatewaySSRUrl = () => {
    const urls = {
        LOCAL: "https://b2c-catalog-gateway.qac24svc.dev",
        STAGING: "https://stage-b2c-catalog-gateway.qac24svc.dev",
        QA: "https://b2c-catalog-gateway.qac24svc.dev",
        LNOD: "https://b2c-catalog-gateway.qac24svc.dev",
        PRODUCTION: "https://b2c-catalog-gateway.c24.tech"
    };
    return urls[currentEnv];
};

const carCatalogGatewayUrl = () => {
    const urls = {
        LOCAL: "https://car-catalog-gateway-in.qac24svc.dev",
        STAGING: "https://stage-car-catalog-gateway-in.qac24svc.dev",
        QA: "https://car-catalog-gateway-in.qac24svc.dev",
        LNOD: "https://car-catalog-gateway-in.qac24svc.dev",
        PRODUCTION: "https://car-catalog-gateway-in.c24.tech"
    };
    return urls[currentEnv];
};

const carCatalogGatewaySSRUrl = () => {
    const urls = {
        LOCAL: "https://car-catalog-gateway-in.qac24svc.dev",
        STAGING: "https://stage-car-catalog-gateway-in.qac24svc.dev",
        QA: "https://car-catalog-gateway-in.qac24svc.dev",
        LNOD: "https://car-catalog-gateway-in.qac24svc.dev",
        PRODUCTION: "https://car-catalog-gateway-in.c24.tech"
    };
    return urls[currentEnv];
};

const c2cBaseUrl = () => {
    const urls = {
        LOCAL: "https://sell24-engine.qac24svc.dev",
        STAGING: "https://stage-sell24-engine.qac24svc.dev",
        QA: "https://sell24-engine.qac24svc.dev",
        LNOD: "https://sell24engine-lnod.ninja24.in",
        PRODUCTION: "https://api-sell24.cars24.team"
    };
    return urls[currentEnv];
};

const c2cBaseSSRUrl = () => {
    const urls = {
        LOCAL: "https://sell24-engine.qac24svc.dev",
        STAGING: "https://stage-sell24-engine.qac24svc.dev",
        QA: "https://sell24-engine.qac24svc.dev",
        LNOD: "https://sell24engine-lnod.ninja24.in",
        // PRODUCTION: "https://api-sell24.cars24.team"
        PRODUCTION: "http://sell24-engine-prod.cars24-service:8080"
    };
    return urls[currentEnv];
};

const cmsSSRUrl = () => {
    const urls = {
        LOCAL: "https://new-car-api.qac24svc.dev",
        STAGING: "https://new-car-api.qac24svc.dev",
        QA: "https://new-car-api.qac24svc.dev",
        LNOD: "https://new-car-api.qac24svc.dev",
        PRODUCTION: "http://new-car-api-prod.cars24.internal"
        // PRODUCTION: "https://new-car-api-prod.cars24.team"
    };
    return urls[currentEnv];
};

const cmsUrl = () => {
    const urls = {
        LOCAL: "https://new-car-api.qac24svc.dev",
        STAGING: "https://new-car-api.qac24svc.dev",
        QA: "https://new-car-api.qac24svc.dev",
        LNOD: "https://new-car-api.qac24svc.dev",
        PRODUCTION: "https://new-car-api-prod.cars24.team"
    };
    return urls[currentEnv];
};

const locationServiceUrl = () => {
    const urls = {
        LOCAL: "https://stage-user-location-service.qac24svc.dev",
        STAGING: "https://stage-user-location-service.qac24svc.dev",
        QA: "https://user-location-service.qac24svc.dev",
        LNOD: "https://stage-user-location-service.qac24svc.dev",
        PRODUCTION: "https://user-location-service.c24.tech"
    };
    return urls[currentEnv];
};

const cmsApiKeys = () => {
    const urls = {
        LOCAL: "13yVBahLnU5j/K?YmOnmmG5?Lt3LN9c1tZ?DiItAtVW2KXOBvgFevwL19-=i2lJZEy7E0cDTcC6zno0jbv8T1wYdredQTw!KGUH0e60CmPMx/exMCBdGDG9EXeXbcJp8DJkShid3qNws59o5g8s=uvnKxC3RndXU64B=1xe75ITpK11Nt4?2HTFxo-c/rqo-U8MP4PPFHdQJ00kwT=24hqm9Yt12KpDZZK9IClwW6u-Xgs/W?E4wNgAQKSze2=5m",
        STAGING: "13yVBahLnU5j/K?YmOnmmG5?Lt3LN9c1tZ?DiItAtVW2KXOBvgFevwL19-=i2lJZEy7E0cDTcC6zno0jbv8T1wYdredQTw!KGUH0e60CmPMx/exMCBdGDG9EXeXbcJp8DJkShid3qNws59o5g8s=uvnKxC3RndXU64B=1xe75ITpK11Nt4?2HTFxo-c/rqo-U8MP4PPFHdQJ00kwT=24hqm9Yt12KpDZZK9IClwW6u-Xgs/W?E4wNgAQKSze2=5m",
        QA: "13yVBahLnU5j/K?YmOnmmG5?Lt3LN9c1tZ?DiItAtVW2KXOBvgFevwL19-=i2lJZEy7E0cDTcC6zno0jbv8T1wYdredQTw!KGUH0e60CmPMx/exMCBdGDG9EXeXbcJp8DJkShid3qNws59o5g8s=uvnKxC3RndXU64B=1xe75ITpK11Nt4?2HTFxo-c/rqo-U8MP4PPFHdQJ00kwT=24hqm9Yt12KpDZZK9IClwW6u-Xgs/W?E4wNgAQKSze2=5m",
        LNOD: "13yVBahLnU5j/K?YmOnmmG5?Lt3LN9c1tZ?DiItAtVW2KXOBvgFevwL19-=i2lJZEy7E0cDTcC6zno0jbv8T1wYdredQTw!KGUH0e60CmPMx/exMCBdGDG9EXeXbcJp8DJkShid3qNws59o5g8s=uvnKxC3RndXU64B=1xe75ITpK11Nt4?2HTFxo-c/rqo-U8MP4PPFHdQJ00kwT=24hqm9Yt12KpDZZK9IClwW6u-Xgs/W?E4wNgAQKSze2=5m",
        PRODUCTION: "13yVBahLnU5j/K?YmOnmmG5?Lt3LN9c1tZ?DiItAtVW2KXOBvgFevwL19-=i2lJZEy7E0cDTcC6zno0jbv8T1wYdredQTw!KGUH0e60CmPMx/exMCBdGDG9EXeXbcJp8DJkShid3qNws59o5g8s=uvnKxC3RndXU64B=1xe75ITpK11Nt4?2HTFxo-c/rqo-U8MP4PPFHdQJ00kwT=24hqm9Yt12KpDZZK9IClwW6u-Xgs/W?E4wNgAQKSze2=5m"
    };
    return urls[currentEnv];
};

const vasCmsApiKeys = () => {
    const urls = {
        LOCAL: "f0f479694b1a4e12b9f1a7664c?!ae7735/516937e7e8e74?!920ba1b?!1ebb0f2f70eb",
        STAGING: "f0f479694b1a4e12b9f1a7664c?!ae7735/516937e7e8e74?!920ba1b?!1ebb0f2f70eb",
        QA: "f0f479694b1a4e12b9f1a7664c?!ae7735/516937e7e8e74?!920ba1b?!1ebb0f2f70eb",
        LNOD: "f0f479694b1a4e12b9f1a7664c?!ae7735/516937e7e8e74?!920ba1b?!1ebb0f2f70eb",
        PRODUCTION: "f0f479694b1a4e12b9f1a7664c?!ae7735/516937e7e8e74?!920ba1b?!1ebb0f2f70eb"
    };
    return urls[currentEnv];
};

const newCarsCmsApiKeys = () => {
    const urls = {
        LOCAL: "f7zNw-4E!K2RMM==JPp3bjMBPn8W?Ta99?g75vC-tJs/VULP3FMy/e24vp6Q?ikz348nGH99jUF77eN2AVcZdaDcZPrHG44aUs!d27R7T!FA8lk=Qi65/98RE=4qzpsQ?Ml/RvyJrpDHJn-AtKbxj3vYVt6FII?g41ewwV?ItqP?9k0djiKJk5K?H8.j",
        STAGING: "f7zNw-4E!K2RMM==JPp3bjMBPn8W?Ta99?g75vC-tJs/VULP3FMy/e24vp6Q?ikz348nGH99jUF77eN2AVcZdaDcZPrHG44aUs!d27R7T!FA8lk=Qi65/98RE=4qzpsQ?Ml/RvyJrpDHJn-AtKbxj3vYVt6FII?g41ewwV?ItqP?9k0djiKJk5K?H8.j",
        QA: "f7zNw-4E!K2RMM==JPp3bjMBPn8W?Ta99?g75vC-tJs/VULP3FMy/e24vp6Q?ikz348nGH99jUF77eN2AVcZdaDcZPrHG44aUs!d27R7T!FA8lk=Qi65/98RE=4qzpsQ?Ml/RvyJrpDHJn-AtKbxj3vYVt6FII?g41ewwV?ItqP?9k0djiKJk5K?H8.j",
        LNOD: "f7zNw-4E!K2RMM==JPp3bjMBPn8W?Ta99?g75vC-tJs/VULP3FMy/e24vp6Q?ikz348nGH99jUF77eN2AVcZdaDcZPrHG44aUs!d27R7T!FA8lk=Qi65/98RE=4qzpsQ?Ml/RvyJrpDHJn-AtKbxj3vYVt6FII?g41ewwV?ItqP?9k0djiKJk5K?H8.j",
        PRODUCTION: "f7zNw-4E!K2RMM==JPp3bjMBPn8W?Ta99?g75vC-tJs/VULP3FMy/e24vp6Q?ikz348nGH99jUF77eN2AVcZdaDcZPrHG44aUs!d27R7T!FA8lk=Qi65/98RE=4qzpsQ?Ml/RvyJrpDHJn-AtKbxj3vYVt6FII?g41ewwV?ItqP?9k0djiKJk5K?H8.j"
    };
    return urls[currentEnv];
};

const PATH_NAME = {
    affiliate: "affiliate",
    marketing: "marketing",
    marketing_v2: "marketing/v2",
    delist: "delist"
};

const catalogUserProfile = () => {
    const urls = {
        LOCAL: "https://b2c-user-profile-in.qac24svc.dev",
        STAGING: "https://stage-b2c-user-profile-in.qac24svc.dev",
        QA: "https://b2c-user-profile-in.qac24svc.dev",
        LNOD: "https://b2c-user-profile-in.qac24svc.dev",
        PRODUCTION: "https://b2c-user-profile-in.c24.tech"
    };
    return urls[currentEnv];
};

const superAppSSRUrl = () => {
    const urls = {
        LOCAL: "https://super-app-backend.qac24svc.dev",
        STAGING: "https://stage-super-app-backend.qac24svc.dev",
        QA: "https://super-app-backend.qac24svc.dev",
        LNOD: "https://super-app-backend.qac24svc.dev",
        PRODUCTION: "http://super-app-backend-prod.cars24.internal"
    };
    return urls[currentEnv];
};

const vasBffUrl = () => {
    const urls = {
        LOCAL: "https://c2b-vas-bff-service-stage.qac24svc.dev",
        STAGING: "https://c2b-vas-bff-service-stage.qac24svc.dev",
        QA: "https://c2b-vas-bff-service.qac24svc.dev",
        LNOD: "https://c2b-vas-bff-service-lnod.qac24svc.dev",
        PRODUCTION: "https://c2b-vas-bff-service.cars24.team"
    };
    return urls[currentEnv];
};

const vasBffSSRUrl = () => {
    const urls = {
        LOCAL: "https://c2b-vas-bff-service-stage.qac24svc.dev",
        STAGING: "https://c2b-vas-bff-service-stage.qac24svc.dev",
        QA: "https://c2b-vas-bff-service.qac24svc.dev",
        LNOD: "https://c2b-vas-bff-service-lnod.qac24svc.dev",
        PRODUCTION: "http://c2b-vas-bff-service-prod.cars24.internal"
    };
    return urls[currentEnv];
};

const superAppUrl = () => {
    const urls = {
        LOCAL: "https://super-app-backend.qac24svc.dev",
        STAGING: "https://stage-super-app-backend.qac24svc.dev",
        QA: "https://super-app-backend.qac24svc.dev",
        LNOD: "https://super-app-backend.qac24svc.dev",
        PRODUCTION: "https://superappapi.cars24.team"
    };
    return urls[currentEnv];
};

const superAppAuthKeys = () => {
    const urls = {
        LOCAL: "bRmPOz?wCnEtvx?rStOyy?HsWZmYhvD6g3zrJBZ6DUc3Q6WvPzuLnM9oF!J5=!B4/uilu/A9zS3B1mI7pgGjG9Z2H3B8YtZrYxJ1jN4w2sZP7B?N2nR4w1R5a",
        STAGING: "bRmPOz?wCnEtvx?rStOyy?HsWZmYhvD6g3zrJBZ6DUc3Q6WvPzuLnM9oF!J5=!B4/uilu/A9zS3B1mI7pgGjG9Z2H3B8YtZrYxJ1jN4w2sZP7B?N2nR4w1R5a",
        QA: "bRmPOz?wCnEtvx?rStOyy?HsWZmYhvD6g3zrJBZ6DUc3Q6WvPzuLnM9oF!J5=!B4/uilu/A9zS3B1mI7pgGjG9Z2H3B8YtZrYxJ1jN4w2sZP7B?N2nR4w1R5a",
        LNOD: "bRmPOz?wCnEtvx?rStOyy?HsWZmYhvD6g3zrJBZ6DUc3Q6WvPzuLnM9oF!J5=!B4/uilu/A9zS3B1mI7pgGjG9Z2H3B8YtZrYxJ1jN4w2sZP7B?N2nR4w1R5a",
        PRODUCTION: "bRmPOz?wCnEtvx?rStOyy?HsWZmYhvD6g3zrJBZ6DUc3Q6WvPzuLnM9oF!J5=!B4/uilu/A9zS3B1mI7pgGjG9Z2H3B8YtZrYxJ1jN4w2sZP7B?N2nR4w1R5a"
    };
    return urls[currentEnv];
};

const superAppCmsAuthKeys = () => {
    const urls = {
        LOCAL: "L3YUY-8NnRSJCHKG/vFYA?bKRcbQORZIsgZtBeJmWNaPQuYJnV0bbQdaKq=IyBku8nJU9gipiaUUwDCM6sItx=bOg-do-e2OZq2kzE=hdj6VDatzl9xFxbo7x!f9dJz1",
        STAGING: "L3YUY-8NnRSJCHKG/vFYA?bKRcbQORZIsgZtBeJmWNaPQuYJnV0bbQdaKq=IyBku8nJU9gipiaUUwDCM6sItx=bOg-do-e2OZq2kzE=hdj6VDatzl9xFxbo7x!f9dJz1",
        QA: "L3YUY-8NnRSJCHKG/vFYA?bKRcbQORZIsgZtBeJmWNaPQuYJnV0bbQdaKq=IyBku8nJU9gipiaUUwDCM6sItx=bOg-do-e2OZq2kzE=hdj6VDatzl9xFxbo7x!f9dJz1",
        LNOD: "L3YUY-8NnRSJCHKG/vFYA?bKRcbQORZIsgZtBeJmWNaPQuYJnV0bbQdaKq=IyBku8nJU9gipiaUUwDCM6sItx=bOg-do-e2OZq2kzE=hdj6VDatzl9xFxbo7x!f9dJz1",
        PRODUCTION: "L3YUY-8NnRSJCHKG/vFYA?bKRcbQORZIsgZtBeJmWNaPQuYJnV0bbQdaKq=IyBku8nJU9gipiaUUwDCM6sItx=bOg-do-e2OZq2kzE=hdj6VDatzl9xFxbo7x!f9dJz1"
    };
    return urls[currentEnv];
};

const newSellerVasCmsAuthKeys = () => {
    const urls = {
        LOCAL: "EP8aEBRH6Ipu9-Ut/eqg7dYfZQjpMFdBhs0jPw1pThZ3CKukSFJkzvW1HD1STIHcg6kjjL!GrjgnkwG?fRlSsGb63Y4=myz5r7NhYXUqo8wawmB6-vQuk358CgtcW41r",
        STAGING: "EP8aEBRH6Ipu9-Ut/eqg7dYfZQjpMFdBhs0jPw1pThZ3CKukSFJkzvW1HD1STIHcg6kjjL!GrjgnkwG?fRlSsGb63Y4=myz5r7NhYXUqo8wawmB6-vQuk358CgtcW41r",
        QA: "EP8aEBRH6Ipu9-Ut/eqg7dYfZQjpMFdBhs0jPw1pThZ3CKukSFJkzvW1HD1STIHcg6kjjL!GrjgnkwG?fRlSsGb63Y4=myz5r7NhYXUqo8wawmB6-vQuk358CgtcW41r",
        LNOD: "EP8aEBRH6Ipu9-Ut/eqg7dYfZQjpMFdBhs0jPw1pThZ3CKukSFJkzvW1HD1STIHcg6kjjL!GrjgnkwG?fRlSsGb63Y4=myz5r7NhYXUqo8wawmB6-vQuk358CgtcW41r",
        PRODUCTION: "EP8aEBRH6Ipu9-Ut/eqg7dYfZQjpMFdBhs0jPw1pThZ3CKukSFJkzvW1HD1STIHcg6kjjL!GrjgnkwG?fRlSsGb63Y4=myz5r7NhYXUqo8wawmB6-vQuk358CgtcW41r"
    };
    return urls[currentEnv];
};

const vasBffAuthKeys = () => {
    const urls = {
        LOCAL: "c34d7d38-3110-48fd-8757-ca32748ff0ff",
        STAGING: "c34d7d38-3110-48fd-8757-ca32748ff0ff",
        QA: "c34d7d38-3110-48fd-8757-ca32748ff0ff",
        LNOD: "c34d7d38-3110-48fd-8757-ca32748ff0ff",
        PRODUCTION: "39a34eda-8186-4d97-88d7-75d1d9259ceb"
    };
    return urls[currentEnv];
};

const aqiAuthKeys = () => {
    const urls = {
        LOCAL: "e3d5b7c4f27a8d9b0a12cd34ef56ab78",
        STAGING: "e3d5b7c4f27a8d9b0a12cd34ef56ab78",
        QA: "e3d5b7c4f27a8d9b0a12cd34ef56ab78",
        LNOD: "e3d5b7c4f27a8d9b0a12cd34ef56ab78",
        PRODUCTION: "c91f6a2e4b78d0c5a31b2f8d7e09c3fa"
    };
    return urls[currentEnv];
};

const c2cUrl = () => {
    const urls = {
        LOCAL: "https://stage-c2c-api-gateway.qac24svc.dev",
        STAGING: "https://stage-c2c-api-gateway.qac24svc.dev",
        QA: "https://stage-c2c-api-gateway.qac24svc.dev",
        LNOD: "https://stage-c2c-api-gateway.qac24svc.dev",
        PRODUCTION: "https://c2c-gateway-service.cars24.team"
    };
    return urls[currentEnv];
};

const cdnImageBaseUrl = () => {
    const urls = {
        LOCAL: "https://img-staging.24c.in",
        STAGING: "https://img-staging.24c.in",
        QA: "https://img-staging.24c.in",
        PRODUCTION: "https://fastly-production.24c.in"
    };
    return urls[currentEnv];
};

const b2cGatewayApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-gateway-india.qac24svc.dev",
        STAGING: "https://stage-b2c-gateway-india.qac24svc.dev",
        QA: "https://b2c-gateway-india.qac24svc.dev",
        LNOD: "https://stage-b2c-gateway-india.qac24svc.dev",
        PRODUCTION: "https://b2c-gateway-india.c24.tech"
    };
    return urls[currentEnv];
};
const feedbackSurveyUrl = () => {
    const urls = {
        LOCAL: "https://insight360.qac24svc.dev",
        STAGING: "https://insight360.qac24svc.dev",
        QA: "https://insight360.qac24svc.dev",
        LNOD: "https://insight360.qac24svc.dev",
        PRODUCTION: "https://insight360.c24.tech"
    };
    return urls[currentEnv];
};

const chatBotApiUrl = () => {
    const urls = {
        STAGING: "https://chit-chat-flow.qac24svc.dev",
        QA: "https://chit-chat-flow.qac24svc.dev",
        PRODUCTION: "https://chit-chat-flow.c24.tech"
    };

    return urls[currentEnv];
};

const chatBotHistoryApiUrl = () => {
    const urls = {
        STAGING: "https://whisper-warehouse.qac24svc.dev",
        QA: "https://whisper-warehouse.qac24svc.dev",
        PRODUCTION: "https://whisper-warehouse.c24.tech"
    };

    return urls[currentEnv];
};

const loans24FinanceApiUrl = () => {
    const urls = {
        LOCAL: "https://dev-fin-partner.theloan24.in",
        STAGING: "https://stage-fin-partner.theloan24.in",
        QA: "https://dev-fin-partner.theloan24.in",
        LNOD: "https://stage-fin-partner.theloan24.in",
        PRODUCTION: "https://partner-bff.loans24.co.in"
    };
    return urls[currentEnv];
};

const loans24D2CApiUrl = () => {
    const urls = {
        LOCAL: "https://dev-loans24-bff.theloan24.in",
        STAGING: "https://stage-loans24-bff.theloan24.in",
        QA: "https://dev-loans24-bff.theloan24.in",
        LNOD: "https://stage-loans24-bff.theloan24.in",
        PRODUCTION: "https://loans24-bff.loans24.co.in"
    };
    return urls[currentEnv];
};

const superAppNewCMSAuthKeys = () => {
    const urls = {
        LOCAL: "f7276db97f3a4d6abb5a84e7c132904a367a211dj10d54ddd3bb795268cde04bb8f5b4c6f9XX3",
        STAGING: "f7276db97f3a4d6abb5a84e7c132904a367a211dj10d54ddd3bb795268cde04bb8f5b4c6f9XX3",
        QA: "f7276db97f3a4d6abb5a84e7c132904a367a211dj10d54ddd3bb795268cde04bb8f5b4c6f9XX3",
        LNOD: "f7276db97f3a4d6abb5a84e7c132904a367a211dj10d54ddd3bb795268cde04bb8f5b4c6f9XX3",
        PRODUCTION: "f7276db97f3a4d6abb5a84e7c132904a367a211dj10d54ddd3bb795268cde04bb8f5b4c6f9XX3"
    };
    return urls[currentEnv];
};

const lacLoans24WebsiteUrl = () => {
    const urls = {
        QA: "https://qa-i2-credit-score-ui.theloan24.in",
        STAGING: "https://theloan24.in",
        LNOD: "https://theloan24.in",
        PRODUCTION: "https://www.loans24.co.in"
    };
    return urls[currentEnv];
};

module.exports = {
    currentEnv,
    appUrl,
    apiUrl,
    baseApiUrl,
    ssrApiUrl,
    getPrivateProductApiKey,
    ppApiUrl,
    c2bAuthKey,
    getLogoURL,
    exchangeApiUrl,
    chatBotHistoryApiUrl,
    lmsAuthKey,
    vehicleApiUrl,
    vehicleSSRApiUrl,
    checkoutApiUrl,
    checkoutApiSSRUrl,
    consumerFinanceApiUrl,
    listingApiUrl,
    leadApiUrlKey,
    c2bKeys,
    leadServiceJavaApi,
    getConsumerFinanceMobileApiKey,
    getConsumerFinanceDesktopApiKey,
    leadServiceJavaSSRApi,
    b2cUserServiceUrl,
    lmsLeadAuthKey,
    carConsumerGatewayApi,
    incidentManagement,
    b2cCrmServiceUrl,
    couponServiceUrl,
    c2cBaseUrl,
    lmsBaseApiUrl,
    PATH_NAME,
    omsAggregatorApi,
    omsAggregatorApiSSRUrl,
    c2cBaseSSRUrl,
    carConsumerGatewaySSRApi,
    getC2bProductApiKey,
    catalogGatewayUrl,
    catalogGatewaySSRUrl,
    getDiyOgImageUrl,
    staticFastlyAppUrl,
    consumerFinanceSSRApiUrl,
    catalogServiceUrl,
    cfLoanServiceUrl,
    cmsSSRUrl,
    cmsUrl,
    cmsApiKeys,
    catalogUserProfile,
    superAppSSRUrl,
    superAppUrl,
    superAppAuthKeys,
    newCarsCmsApiKeys,
    vasCmsApiKeys,
    c2cUrl,
    cdnImageBaseUrl,
    b2cGatewayApiUrl,
    aqiAuthKeys,
    loans24FinanceApiUrl,
    chatBotApiUrl,
    feedbackSurveyUrl,
    superAppCmsAuthKeys,
    superAppNewCMSAuthKeys,
    loans24D2CApiUrl,
    vasIndiaWebsiteUrl,
    newSellerVasCmsAuthKeys,
    carCatalogGatewayUrl,
    carCatalogGatewaySSRUrl,
    supplyIndiaWebsiteUrl,
    locationServiceUrl,
    vasBffUrl,
    vasBffAuthKeys,
    vasBffSSRUrl,
    lacLoans24WebsiteUrl,
    homepageIndiaWebsiteUrl
};
